import { Input } from '@angular/core';
// @Directive({
// 	selector: ''
// })
var ClassBaseDirective = /** @class */ (function () {
    function ClassBaseDirective(el, renderer, service) {
        this.el = el;
        this.renderer = renderer;
        this.service = service;
    }
    ClassBaseDirective.prototype.ngOnInit = function () {
        this.tag = this.el.nativeElement.tagName.toLowerCase();
        this.onInit();
    };
    ClassBaseDirective.prototype.onInit = function () {
        if (this.key) {
            this.setDefClass(this.key, this.tag);
        }
    };
    ClassBaseDirective.prototype.setDefClass = function (key, path) {
        var def = this.service.getClass(key, path);
        if (def) {
            this.addClass(def);
        }
    };
    ClassBaseDirective.prototype.addClass = function (add) {
        if (typeof add === 'string') {
            // "class1" or "class1 class2 ..."
            var adds = add.split(' ');
            for (var _i = 0, adds_1 = adds; _i < adds_1.length; _i++) {
                var cls = adds_1[_i];
                this.renderer.addClass(this.el.nativeElement, cls);
            }
        }
        else if (add instanceof Array) {
            // ["class1", "class2", ...]
            for (var _a = 0, add_1 = add; _a < add_1.length; _a++) {
                var cls = add_1[_a];
                this.renderer.addClass(this.el.nativeElement, cls);
            }
        }
    };
    ClassBaseDirective.prototype.removeClass = function (cls) {
        this.renderer.removeClass(this.el.nativeElement, cls);
    };
    ClassBaseDirective.propDecorators = {
        key: [{ type: Input }]
    };
    return ClassBaseDirective;
}());
export { ClassBaseDirective };
//# sourceMappingURL=classbase.directive.js.map